import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'
import { MetricsHelper } from 'helpers'

class LinkStatus extends Component {
  constructor (props) {
    super(props)
    this.state = {
      linkStatus: null,
      hardware: null,
      linkerr: false,
      hwerr: false,
      loading: true
    }
  }
  componentDidMount () {
    this.setState({loading: true})
    this.setLinkStatus(this.props.linkStatus, this.props.linkerr)
    this.setHardware(this.props.hardware, this.props.hwerr)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true, linkStatus: null, hardware: null})
    this.setLinkStatus(props.linkStatus, props.linkerr)
    this.setHardware(props.hardware, props.hwerr)
  }
  async setLinkStatus (linkStatus, linkerr) {
    if (!linkStatus && !linkerr.error) return
    if (linkerr.error) return this.setState({linkerr: linkerr, loading: false})
    this.setState({linkStatus: linkStatus, linkerr: false, loading: false})
  }
  async setHardware (hardware, hwerr) {
    if (!hardware && !hwerr.error) return
    if (hwerr.error) return this.setState({hwerr: hwerr, loading: false})
    this.setState({hardware: hardware, hwerr: false, loading: false})
  }
  reload () {
    this.setState({loading: true})
    this.props.reload()
  }
  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='Link Status' icon='server' buttons={[{ icon: 'fa-refresh', event: () => this.reload() }]}>
        <div className='row'>
          <div className='col-md-12'>
            <span className='label label-dark large-label'><b>Hardware</b></span>
            {this.state.hardware &&
              <pre className='no-overflow mt-10 no-padding'>
                <FlowTable noClass data={[[
                  (this.state.hardware.up ? <span className='label orders-label label-success'>UP</span> : <span className='label orders-label label-danger'>DOWN</span>),
                  this.state.hardware.upSince,
                  this.state.hardware.vendor,
                  this.state.hardware.model
                ]]}>
                  <tr>
                    <th>Up</th>
                    <th>Up Since</th>
                    <th>Vendor</th>
                    <th>Model</th>
                  </tr>
                </FlowTable>
              </pre>
            }
            {this.state.hwerr &&
              <pre className='table-pre mt-10'>
                <div className='error-wrapper'>
                  <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching hardware {this.state.hwerr.cause ? '- ' + this.state.hwerr.cause : ''}</b></span>
                </div>
              </pre>
            }
          </div>
          <div className='col-md-12'>
            <span className='label label-dark large-label'><b>Link</b></span>
            {this.state.linkStatus &&
              <div>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={[[
                    (this.state.linkStatus.link ? <span className='label orders-label label-success'>UP</span> : <span className='label orders-label label-danger'>DOWN</span>),
                    (this.state.linkStatus.fullDuplex ? <span className='label orders-label label-success'>YES</span> : <span className='label orders-label label-danger'>NO</span>),
                    this.state.linkStatus.linkSince,
                    this.state.linkStatus.speed,
                    this.state.linkStatus.linkSpeed
                  ]]}>
                    <tr>
                      <th>Link</th>
                      <th>Full Duplex</th>
                      <th>Link Since</th>
                      <th>Speed</th>
                      <th>Link Speed</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>Link - Configured Speed</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={this.state.linkStatus.configuredSpeed.map(obj => [
                    obj.serviceType,
                    obj.queue,
                    obj.cir,
                    obj.pir
                  ])}>
                    <tr>
                      <th>Service Type</th>
                      <th>Queue</th>
                      <th>CIR</th>
                      <th>PIR</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>Link - Fiber</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={[Object.values(this.state.linkStatus.fiber)]}>
                    <tr>
                      <th>dbmRx</th>
                      <th>dbmTx</th>
                      <th>Temp</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>Link - Statistics</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={[[this.state.linkStatus.statistics.counterResetAt]]}>
                    <tr>
                      <th>Counter reset at</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>Link - Statistics - Peak Rate</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={(this.state.linkStatus.statistics.peakInputRate || this.state.linkStatus.statistics.peakOutputRate ? [
                    Object.values(Object.assign({'type': 'Input'}, this.state.linkStatus.statistics.peakInputRate)),
                    Object.values(Object.assign({'type': 'Output'}, this.state.linkStatus.statistics.peakOutputRate))
                  ] : [])}>
                    <tr>
                      <th>Type</th>
                      <th>Counter</th>
                      <th>Timestamp</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>Link - Statistics - Last Five</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={[
                    Object.values(Object.assign({'type': 'Input'}, MetricsHelper.lastFive(this.state.linkStatus.statistics.lastFiveInput))),
                    Object.values(Object.assign({'type': 'Output'}, MetricsHelper.lastFive(this.state.linkStatus.statistics.lastFiveOutput)))
                  ]}>
                    <tr>
                      <th>Type</th>
                      <th>Packets</th>
                      <th>Bytes</th>
                    </tr>
                  </FlowTable>
                </pre>
                <span className='label label-dark large-label'><b>Link - Statistics - Metrics</b></span>
                <pre className='no-overflow mt-10 no-padding'>
                  <FlowTable noClass data={[
                    Object.values(Object.assign({'type': 'Input'}, MetricsHelper.full(this.state.linkStatus.statistics.input))),
                    Object.values(Object.assign({'type': 'Output'}, MetricsHelper.full(this.state.linkStatus.statistics.output)))
                  ]}>
                    <tr>
                      <th>Type</th>
                      <th>Packets</th>
                      <th>Bytes</th>
                      <th>Unicast</th>
                      <th>Broadcast</th>
                      <th>Multicast</th>
                      <th>Pauses</th>
                      <th>Bytes</th>
                      <th>CRC-Errors</th>
                    </tr>
                  </FlowTable>
                </pre>
              </div>
            }
            {this.state.linkerr &&
              <pre className='table-pre mt-10'>
                <div className='error-wrapper'>
                  <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching Link Status {(this.state.linkerr.cause ? '- ' + this.state.linkerr.cause : '')}</b></span>
                </div>
              </pre>
            }
          </div>
        </div>
      </StaticBox>
    )
  }
}
export default LinkStatus



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/troubleshooting/LinkStatus.js